import type { Dayjs } from "dayjs";
import dayjs from "../dayjs";

export function sanitizeDayjs(value: Dayjs | null, fallback: Dayjs): Dayjs {
  return value?.isValid() ? value : fallback;
}

export function startOfPreviousMonth() {
  return dayjs().subtract(1, "month").startOf("month");
}

export function endOfCurrentYear() {
  return dayjs().endOf("year");
}

export function endOfNextYear() {
  return dayjs().add(1, "year").endOf("year");
}

export function startOfTheCurrentOrPreviousYear() {
  const today = dayjs();
  if (today.month() === 0) {
    return today.subtract(1, "month").startOf("year");
  }
  return today.startOf("year");
}
